import { FC, ReactNode } from "react";
import { StyledEmpty } from "./styled";

type Props = {
  title: string;
  text?: string;
  children?: ReactNode;
};

const Empty: FC<Props> = ({ title, text, children }) => (
  <StyledEmpty>
    <h3>{title}</h3>
    {!!text && (
      <p>{text}</p>
    )}
    {children}
  </StyledEmpty>
);

export default Empty;
